// Defaults to whatever host the page itself was loaded from, so the emulator
// connections just work whether that's 'localhost' (the machine running the
// emulator) or a LAN IP (a phone on the same Wi-Fi hitting `vite --host`) —
// no per-developer .env edit or hardcoded IP needed. VITE_EMULATOR_HOST still
// overrides it for edge cases (e.g. a tunnel with its own hostname). Native
// Capacitor builds report 'localhost' here too (their WebView's default
// host), so this doesn't change behaviour there.
export const EMULATOR_HOST =
  import.meta.env?.VITE_EMULATOR_HOST ??
  (typeof window !== 'undefined' ? window.location.hostname : 'localhost')

export const LAB_CLOUD_URL = {
  EMULATOR: `http://${EMULATOR_HOST}:5001/lab-services-dev/europe-west3`,
  DEV: 'https://europe-west3-lab-services-dev.cloudfunctions.net',
  PROD: 'https://europe-west3-lab-services-prod.cloudfunctions.net',
} as const

